"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function LatestPostsConsumer() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center">
        <p className="mb-4 text-muted-foreground">Failed to load the latest economic insights.</p>
        <Button onClick={refetch} variant="outline" className="rounded-sm border-primary text-primary font-default">
          Try Again
        </Button>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-12 text-center">
        <p className="text-muted-foreground">No media releases available at the moment.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group relative flex h-full flex-col bg-background p-6 border border-border">
          {}
          <div className="border-primary absolute top-0 left-0 h-12 w-12 border-t border-l transition-transform duration-300 group-hover:-translate-x-1 group-hover:-translate-y-1" />
          <div className="border-primary absolute right-0 bottom-0 h-12 w-12 border-r border-b transition-transform duration-300 group-hover:translate-x-1 group-hover:translate-y-1" />

          {post.featuredImage && <div className="mb-6 aspect-[4/3] overflow-hidden bg-muted">
              <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover grayscale contrast-125 transition-transform duration-700 group-hover:scale-105" />
            </div>}

          <div className="flex flex-grow flex-col">
            <div className="mb-2 font-mono text-xs uppercase tracking-wider text-muted-foreground">
              {new Date(post.date).toLocaleDateString('en-AU', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          })}
            </div>
            <h3 className="font-default text-foreground mb-4 line-clamp-2 text-2xl font-bold leading-tight tracking-tight">
              {post.title}
            </h3>
            
            {post.excerpt && <div className="text-muted-foreground mb-6 line-clamp-3 text-sm font-default" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
            
            <div className="mt-auto pt-4">
              <Link to={post.link || "#"} className="group/link text-primary hover:text-primary/80 inline-flex items-center font-mono text-xs font-bold uppercase tracking-widest transition-colors">
                Read Brief
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-2" />
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function LatestFromTheOven() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="222194" id="latest-economic-insights" className="bg-background text-foreground">
      <div className="bg-background py-24">
        <div className="container mx-auto max-w-7xl px-4 md:px-6">
          <div className="mb-16 text-center">
            <h2 className="font-default text-foreground mb-4 text-4xl md:text-5xl font-bold tracking-tighter">
              Latest Economic Insights
            </h2>
            <div className="bg-primary mx-auto h-0.5 w-24" />
          </div>

          <PostsProvider wp_query={{
          post_type: "post",
          per_page: 3,
          orderby: "date",
          order: "desc"
        }}>
            <LatestPostsConsumer />
          </PostsProvider>

          <div className="mt-16 text-center">
            <Link to="/MediaCentrePage">
              <Button variant="outline" className="rounded-sm border-primary text-primary font-default px-8 py-6 text-lg hover:bg-primary hover:text-primary-foreground transition-all">
                View All Media
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}